module.exports = __webpack_public_path__ + "img/error.6b04c690.png";